/**
 * Central React Flow node-type registry for the Metric Tree canvas. Maps each
 * palette node type to its renderer. `rfTypeFor` converts a stored node `type`
 * (metric/strategy/note/text/media) into the React Flow component key.
 */
import MetricNode from './MetricNode';
import { StrategyNode, NoteNode, TextNode, MediaNode } from './AnnotationNodes';

export const canvasNodeTypes = {
  metricNode: MetricNode,
  strategyNode: StrategyNode,
  noteNode: NoteNode,
  textNode: TextNode,
  mediaNode: MediaNode,
};

const RF_TYPE = {
  metric: 'metricNode',
  strategy: 'strategyNode',
  note: 'noteNode',
  text: 'textNode',
  media: 'mediaNode',
};

export const rfTypeFor = (type) => RF_TYPE[type] || 'metricNode';
